import FieldRepeatNewPassword from './FieldRepeatNewPassword';
export default FieldRepeatNewPassword;
